<template>
  <dt class="flex gap-100 items-center paragraph-bold" data-testid="price-list-per-play">
    <slot />

    <span v-if="name === 'extrahit' && lines" class="paragraph-small-text">
      {{ $t('common.words.lines', lines) }}
    </span>

    <span
      v-if="numberOfPlays > 1"
      class="number-of-plays flex items-center justify-center paragraph-small-text rounded-s px-050"
    >
      {{ $t('pricelist.perplay.label', { amount: numberOfPlays }) }}
    </span>
  </dt>
</template>

<script lang="ts" setup>
type PricePerPlayProps = {
  lines?: Maybe<number>
  name?: Maybe<string>
  numberOfPlays: number
}

defineProps<PricePerPlayProps>()
</script>

<style lang="scss" scoped>
.number-of-plays {
  width: auto;
  height: 1.375rem;
  background-color: token('color/background/secondary/secondary');
  color: token('color/text/primary/primary');
}
</style>
